export default __webpack_public_path__ + "static/media/na_slodko.88406545.svg";